import data from "../Config/config.json"

export function useConfig() {
    return data;
}